export default {
  title: "Операциялар тарыхы",
  number: "Номер",
  entityName: "Уюмдун аты",
  type: "Операциянын түрү",
  typeBuyTariff: "Тариф сатып алуу",
  typeAddBalance: "Баланс толуктоо",
  typePaymentAct: "Акты боюнча эсепти төлөө",
  typePaymentAcceptance: "Сынамык төлөмдү төлөө",
  amount: "Сумма",
  currency: "Валюта",
  date: "Дата жана убакыт",
  noHistory: "Сиздин тарых бош",
  operationsTab: "Бардык операциялар",
  processingTab: "RC Processing",
  reward: "Сыйлык",
  paidFromPurchase:
    "{cash} {currency} төлөндү <span>({amount} {currency} сатып алуудан)</span>",
  downloadModal: {
    title: "Файлды жүктөө",
    fileType: "Файлдын түрү",
    sendOnEmail: "Копияны почтага жөнөтүү",
    CPUnloadingOperationHistory: "(КП) Операциялар тарыхын чыгаруу",
  },
  couldntCreateUnloading: "Чыгарууну түзүү мүмкүн болбой калды",
  giftCard: "Белек картасы",
  orderNumber: "Заказ номери",
  paymentMethod: "Төлөө ыкмасы",
  inCheckSpecifiedPercentAndSumAward:
    "Чекте жалпы пайыз жана сыйлык суммасы көрсөтүлгөн.",
  itsMayNotMatchWithFactSum:
    "Ал фактический чыгарылган балл суммасына дал келбеши мүмкүн, анткени кайсы кардар сатып алганы (ички же тышкы) жана анын тарифине жараша болот.",
};
